import { render } from "./Dashboard.vue?vue&type=template&id=335676de&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=335676de&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-335676de"

export default script